import { render, staticRenderFns } from "./PaymentMethodsPreference.vue?vue&type=template&id=5221e441&"
import script from "./PaymentMethodsPreference.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports